import Link from 'next/link';

import { cn } from '@/lib/utils';
import { siteConfig } from '@/config/site';
import './seo-block.css';

interface SeoBlockProps {
  className?: string;
}

export function SeoBlock({ className }: SeoBlockProps) {
  const { city } = siteConfig;

  return (
    <section className={cn('azia-seo', className)} aria-label="О доставке роллов">
      <h2 className="azia-seo-title">
        Доставка роллов и суши в {city.nameGenitive} — {siteConfig.name}
      </h2>
      <div className="azia-seo-copy">
        <p className="azia-seo-intro">
          <strong>{siteConfig.name}</strong> — это быстрая{' '}
          <strong>доставка роллов в {city.nameGenitive}</strong> прямо к вашей двери.
        </p>
        {/* Native disclosure keeps all text in the server HTML and works without JavaScript. */}
        <details className="azia-seo-details">
          <summary>
            <span className="azia-seo-expand-label">Подробнее о доставке</span>
            <span className="azia-seo-collapse-label">Свернуть</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="m6 9 6 6 6-6"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </summary>
          <div className="azia-seo-body">
            <p>
              Заказать роллы, суши, сеты и блюда японской кухни можно онлайн на сайте или в нашем
              приложении. Среднее время доставки — {siteConfig.deliveryTime.min}–
              {siteConfig.deliveryTime.max} минут, а в некоторые районы мы успеваем за 30 минут.
            </p>
            <p>
              В нашем меню — <strong>запечённые роллы</strong>, <strong>холодные роллы</strong>,{' '}
              <strong>темпура</strong>, классическая <strong>филадельфия</strong>, авторские сеты и
              многое другое. Все блюда готовятся из свежих ингредиентов с соблюдением традиций
              японской кухни. Мы работаем ежедневно с {siteConfig.workingHours.start}:00 до{' '}
              {siteConfig.workingHours.end}:00.
            </p>
            <p>
              Мы доставляем по всему {city.name} и ближайшим пригородам:{' '}
              {city.districts.slice(0, 4).map((d, i) => (
                <span key={d.slug}>
                  {i > 0 && ', '}
                  {d.name}
                </span>
              ))}{' '}
              и <Link href="/delivery#delivery-map">другие районы</Link>. Минимальная сумма заказа —{' '}
              {siteConfig.minOrderAmount} ₽.
            </p>
            <p>
              Не знаете, <strong>где заказать роллы в {city.nameGenitive}</strong>? Почитайте{' '}
              <Link href="/reviews">отзывы наших клиентов</Link> или загляните в{' '}
              <Link href="/faq">частые вопросы</Link>.{' '}
              <strong>Вкусные роллы с доставкой на дом</strong> — это просто и быстро с{' '}
              {siteConfig.name}!
            </p>
          </div>
        </details>
      </div>
    </section>
  );
}
